<template>
    <div>
      <!-- Main content -->
      <section class="content">
        <div class="box info-box">
          <div class="box-header with-border">
            Search By
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <label for="Branch">Branch</label>
                <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchRecord(branch)"></v-select>
                
                <has-error
                  :form="form"
                  field="branch_id"
                ></has-error>
              </div>
              <div class="col-md-3">
                <label for="Branch">Member (Type Here)</label>
                <v-select v-model="member" name="member_id" :filterable="false" label="name" :options="members" placeholder="Select Member" @search="getMemberRecords" v-on:input="getRecordMemberWise"></v-select>
                
                <has-error
                  :form="form"
                  field="staff_id"
                ></has-error>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- Default box -->
        <div class="info-box"  v-if="canAccess('loan-disbursement-view-any')">
          <div class="box-header with-border">
            <h3 class="box-title">Loan Topup List</h3>
            
            <div class="box-tools">
              <button type="button" class="btn btn-success btn-sm" @click="newModalTopup" v-if="canAccess('loan-disbursement-create-loan')">
                <i class="fa fa-plus"></i> Add New
              </button>
            </div>
  
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <label>
                  <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <div class="col-sm-6 col-xs-6">
                <div class="input-group pull-right input-group-sm" style="width: 150px;">
                  <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">
  
                  <div class="input-group-btn">
                    <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div style="overflow:auto;">
              <table class="table table-sm table-bordered table-hover">
                <thead style="background-color: #d6dddd;">
                  <tr>
                    <th class="hidden-xs">Sr.</th>
                    <th>Apply Loan Amt</th>
                    <th>Member</th>
                    <th class="hidden-xs">Branch Name</th>
                    <th class="hidden-xs">Pre Loan ID</th>
                    <th class="hidden-xs">Pre Loan Total Amount</th>
                    <th class="hidden-xs">Pre Loan Due Amount</th>
                    <th class="hidden-xs">Pre Loan Due Principal Amount</th>
                    <th class="hidden-xs">Pre Loan Due Interest Amount</th>
                    <th class="hidden-xs">Pre Loan Due Forclose Charges</th>
                    <th class="hidden-xs">Pre Loan Discount</th>

                    <th class="hidden-xs">Created By</th>
                    <th class="hidden-xs">Status</th>
                    
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in rows" :key="index">
                    <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                    <td>{{ row.new_loan_amt }}</td>
                    <td><a v-if="row.member"
                        @click="viewMemberAddDetail(row.member_id)" >
                        {{row.member.name}} ({{row.member.code}})
                        </a>
                    </td>
                    <td class="hidden-xs">{{ row.branch.name }} ({{ row.branch.branchCode }})</td>
                    <td class="hidden-xs">{{ row.previous_member_loan_plan.applicationNo }}</td>
                    <td class="hidden-xs">{{ row.previous_loan_amt }}</td>
                    <td class="hidden-xs">{{ row.previous_due_amt }}</td>
                    <td class="hidden-xs">{{ row.previous_loan_due_principal_amt }}</td>
                    <td class="hidden-xs">{{ row.previous_loan_due_interest_amt }}</td>
                    <td class="hidden-xs">{{ row.previous_loan_forclose_charges }}</td>
                    <td class="hidden-xs">{{ row.previous_loan_discount }}</td>
                    <td class="hidden-xs"><span v-if="row.created_by">{{ row.created_by.name }} ({{row.created_by.code}})</span></td>
                    <td class="hidden-xs">{{ row.status }}</td>
  
                    <td>
                      <div class="btn-group">
                        <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                          Task <span class="caret"></span>
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right" role="menu">
                          <!-- <li v-if="canAccess('loan-disbursement-view')">
                            <a @click="viewPreviousLoanRecords(row)" title="Previous Loan">
                              <i class="fa fa-leanpub"></i> Previous Loan
                            </a>
                          </li> -->
                          <li v-if="canAccess('loan-disbursement-create') && row.status === 'pending'">
                            <a @click="applyTopupApprove(row)" title="Loan Topup Approve">
                              <i class="fa fa-leanpub"></i> Loan Topup Approve
                            </a>
                          </li>
                          <li v-show="row.filechargeStatus == 'exclude'">
                            <a @click="fileChargeModal(row)" title="File Charge">
                              <i class="fa fa-file"></i> File Charge
                            </a>
                          </li>
                          <li v-show="row.processingFeeStatus == 'exclude'">
                            <a @click="processingFeeModal(row)" title="Processing Fee">
                              <i class="fa fa-hourglass"></i> Processing Fee
                            </a>
                          </li>
                          <li v-show="row.insuranceFeeStatus == 'exclude'">
                            <a @click="insuranceFeeModal(row)" title="Insurance Fee">
                              <i class="fa fa-user-md"></i> Insurance Fee
                            </a>
                          </li>
                          <li v-if="canAccess('loan-disbursement-view')">
                            <a @click="viewTopupRecord(row)" title="View">
                              <i class="fa fa-money"></i> View
                            </a>
                          </li>
                          <!-- <li v-if="canAccess('loan-disbursement-delete')">
                            <a  @click="deleteTopup(row.id)">
                              <i class="fa fa-trash"></i> Delete
                            </a>
                          </li> -->
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /.box-body -->
          <div class="box-footer clearfix" v-if="pagination.current_page > 0">
            <div class="row">
              <div class="col-sm-4">
                Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
              </div>
              <div class="col-sm-8">
                <ul class="pagination pagination-sm no-margin pull-right">
                  <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                  <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>
  
                  <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                  <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                  <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                  <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                  <li><a href="#">...</a></li>
                  
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                  <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>
  
                  <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                  <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box -->
        <div class="modal fade" id="newModalTopup">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Add New</h4>
                <h4 v-show="editMode" class="modal-title">Update</h4>
              </div>
              <form @submit.prevent="editMode ? updateLoan() : createTopup()">
                <div class="modal-body">
                  <!-- right column -->
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Branch <span class="red">*</span></label>
                              <select
                                v-model="form.branch_id"
                                name="branch_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_id'),
                                }"
                                @change="getMemberAndGroupAndAgent"
                                required
                              >
                                <option v-if="!form.branch_id" selected value="">
                                  Select Branch
                                </option>
                                <option
                                  :value="bra.id"
                                  v-for="bra in branches"
                                  :key="bra.id"
                                >
                                  {{ bra.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="branch_id"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Member <span class="red">*</span></label>
                              <v-select v-model="mem"  name="member_id" label="name" :options="members" placeholder="Select Member" v-on:input="getBranchMember">
                                
                              </v-select>
                              
                              <has-error
                                :form="form"
                                field="member_id"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <table class="table table-sm table-bordered table-hover" v-if="memberloanplans.length > 0">
                              <thead style="background-color: #d6dddd;">
                                <tr>
                                    <th class="hidden-xs">Select</th>
                                    <th>Loan Details </th>
                                    <th>Payment Details</th>
                                    <th class="hidden-xs">Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(mlp, id) in memberloanplans" :key="id">
                                    <td class="hidden-xs"><input type="radio" name="previous_member_loan_plan_id" class="minimal" :value="mlp.id"  v-model="form.previous_member_loan_plan_id" @change="getLoanEMI(mlp)"></td>
                                    <td>
                                        <strong>Application No :</strong> {{ mlp.applicationNo }} <br>
                                        <strong>Plan Name : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'name') }} <br>
                                        <strong>Plan Type : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'planType') }} <br>
                                        <!-- <strong>No Of EMI : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'noOfPayments') }} <br> -->
                                        <strong>Type :</strong> {{ mlp.type }} <br>
                                        <i v-if="mlp.collection_center_id"><strong>Group :</strong>{{ mlp.collection_center.name }} ({{ mlp.collection_center.centerCode }}) <br></i>
                                        <strong>Branch : </strong>{{ mlp.branch.name }}
                                    </td>
                                    <td>
                                        <strong>Payable Amount : </strong>{{ mlp.totalAmt }} <br>
                                        <strong>Plan Amount : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'loanAmount') }} <br>
                                        <strong>Disbursement Amount : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'disbursementAmount') }} <br>
                                        <strong class="text-success">Paid Amount : </strong>{{ mlp.receivedAmt }}<br>
                                        <strong class="text-danger">Due Amount : </strong>{{ mlp.totalAmt - mlp.receivedAmt }}<br>
                                        <strong>Received Penalty : </strong> {{ mlp.receivedPanulty }}
                                    </td>
                                    <td class="hidden-xs">
                                        <strong>Disbursement : </strong>{{ mlp.disbursement.disbursementDate | myDate }}<br>
                                        <strong>First EMI : </strong>{{ mlp.disbursement.emiStartDate | myDate }}<br>
                                        <strong>Last EMI : </strong>{{ mlp.disbursement.emiEndDate | myDate }}
                                    </td>
                                    
                                </tr>
                              </tbody>
                            </table>
                            <p><strong>EMI Details</strong></p>
                            <table class="table table-sm table-bordered table-hover" v-if="memberEMIs.length > 0">
                              <thead style="background-color: #d6dddd;">
                                <tr>
                                    <th>No of EMI </th>
                                    <th>Paid No of EMI</th>
                                    <th>Due No of EMI</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                    <td>{{ form.previous_no_of_emi }}</td>
                                    <td>{{ form.previous_paid_no_of_emi }}</td>
                                    <td>{{ form.previous_due_no_of_emi }}</td>
                                </tr>
                              </tbody>
                            </table>
                            <!-- text input -->
                          </div>
                          <div class="col-md-6" v-if="memberEMIs.length > 0">
                            <p>
                              <strong>Due Principal Amount : </strong> {{ form.previous_loan_due_principal_amt }} <br>
                              <strong>Due Interest Amount : </strong> {{ form.previous_loan_due_interest_amt }} <br>
                              <br>
                              <strong>Amount : </strong> {{ paybleAmt }} <br>
                              <strong>Amount With Forclose Charge : </strong> {{ paybleAmtWithForCloseCharge }} <br>
                              <strong>Payable Amount With Discount : </strong> {{ paybleAmtWithDiscount }}
                            </p>
                          </div>
                          <div class="col-md-6" v-if="memberEMIs.length > 0">
                            <div class="form-group">
                              <label
                                >For Close Charge <span class="red">*</span></label
                              >
                              <input
                                v-model="form.previous_loan_forclose_charges"
                                @change="getPaybleAmount"
                                type="number"
                                name="previous_loan_forclose_charges"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('previous_loan_forclose_charges'),
                                }"
                                placeholder="Enter For Close Charges"
                                required
                              />
                              <has-error
                                :form="form"
                                field="previous_loan_forclose_charges"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Write Off Interest Amount <span class="red">*</span></label
                              >
                              <input
                                v-model="form.previous_loan_discount"
                                @change="getPaybleAmount"
                                type="text"
                                name="previous_loan_discount"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('previous_loan_discount'),
                                }"
                                placeholder="Write Off Interest Amount"
                                required
                              />
                              <has-error
                                :form="form"
                                field="previous_loan_discount"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >New Loan Amount <span class="red">*</span></label
                              >
                              <input
                                v-model="form.new_loan_amt"
                                type="text"
                                name="new_loan_amt"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('new_loan_amt'),
                                }"
                                placeholder="Write Off Interest Amount"
                                required
                              />
                              <has-error
                                :form="form"
                                field="new_loan_amt"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    CREATE
                  </button>
                  <button v-show="editMode" type="submit" class="btn btn-success">
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <div class="modal fade" id="newModalLoan">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Apply For Loan Topup Approve</h4>
                <h4 v-show="editMode" class="modal-title">Update Loan</h4>
              </div>
              <form @submit.prevent="editMode ? updateLoan() : createLoan()">
                <div class="modal-body">
                  <!-- right column -->
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Branch Center<span class="red">*</span></label>
                              <v-select v-model="branchcenter" name="branch_center_id" label="name" :options="branchcenters" placeholder="Select Staff" v-on:input="branchCenterWiseRecord">

                              </v-select>
                              <has-error
                                :form="form"
                                field="branch_center_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Staff ID <span class="red">*</span></label>
                              <v-select v-model="staf" name="agent_id" label="name" :options="staffs" placeholder="Select Staff" v-on:input="getBranchAgent">

                              </v-select>
                              <has-error
                                :form="form"
                                field="agent_id"
                              ></has-error>
                            </div>
                            
                            <!-- text input -->
                            <div class="form-group">
                              <label>Purpose <span class="red">*</span></label>
                              <v-select v-model="form.purpose" name="purpose" label="name" placeholder="Select purpose" :options="purposes" v-on:input="getSelectPurpose"></v-select>
                              <has-error :form="form" field="purpose_id"></has-error>
                              <input
                                type="hidden"
                                name="purpose_id"
                                v-model="form.purpose_id"
                              />
                            </div>
                          </div>

                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Plan <span class="red">*</span></label>
                              <v-select v-model="form.plan" name="plan" label="name" placeholder="Select Plan" :options="loanplans" v-on:input="getSelectPlan"></v-select>
                              <has-error :form="form" field="plan_id"></has-error>
                              <input
                                type="hidden"
                                name="plan_id"
                                v-model="form.plan_id"
                              />
                            </div>
                            <div class="form-group">
                              <label
                                >Description<span class="red">*</span></label
                              >
                              <input
                                v-model="form.description"
                                type="text"
                                name="description"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('description'),
                                }"
                                placeholder="Enter Description"
                              />
                              <has-error
                                :form="form"
                                field="description"
                              ></has-error>
                            </div>
                            <div class="form-group" v-if="form.planType == 'individual'">
                              <label>Guarantor </label>
                              <v-select v-model="guarantor"  name="guarantor_id" label="name" :options="members" placeholder="Select Member" v-on:input="getLoanGuarantor">
                                
                              </v-select>
                              
                              <has-error
                                :form="form"
                                field="guarantor_id"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    CREATE
                  </button>
                  <button v-show="editMode" type="submit" class="btn btn-success">
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
        <!-- /.modal-dialog -->
      </div>
        <!-- /.modal -->
        <div class="modal fade" id="disbursmentModal">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Disbursement Loan</h4>
              </div>
              <form @submit.prevent="createDisbursement()">
                <div class="modal-body">
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>
                                Disbursement Date
                                <span class="red">*</span></label
                              >
                              <input
                                v-model="form.disbursementDate"
                                type="date"
                                name="disbursementDate"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'disbursementDate'
                                  ),
                                }"
                                placeholder="Enter joining Date"
                                required
                              />
                              <has-error
                                :form="form"
                                field="disbursementDate"
                              ></has-error>
                              <input
                                type="hidden"
                                name="disbursement_id"
                                v-model="form.disbursement_id"
                              />
                            </div>
  
                            <div class="form-group">
                              <label
                                >EMI Start Date <span class="red">*</span></label
                              >
                              <input
                                v-model="form.emiStartDate"
                                type="date"
                                name="emiStartDate"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('emiStartDate'),
                                }"
                                placeholder="Enter joining Date"
                                required
                              />
                              <has-error
                                :form="form"
                                field="emiStartDate"
                              ></has-error>
                            </div>
                          </div>
  
                          <div class="col-sm-6">
                            
                            <div class="form-group">
                              <label>Select Ledger Account </label>
                              <select
                                v-model="form.branch_ledger_id"
                                name="branch_ledger_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_ledger_id'),
                                }"
                              >
                                <option v-if="!form.branch_ledger_id" selected value="">
                                  Select Ledger Account
                                </option>
                                <option
                                  :value="bank_account.id"
                                  v-for="bank_account in bank_accounts"
                                  :key="bank_account.id"
                                >
                                  {{bank_account.name}} {{bank_account.remark}}
                                </option>
                              </select>
                              <has-error :form="form" field="branch_ledger_id"></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    
                  <!--/.col (right) -->
                </div>
                <div class="modal-footer text-center">
                  <button type="submit" class="btn btn-success">
                    DISBURSEMENT
                  </button>
  
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <view-loan-plan :seeRecord="this.seeRecord" :pl="this.pl" :memberDetail="this.memberDetail" :getCompanyRecord="this.getCompanyRecord" :logo="this.logo"></view-loan-plan>
        <!-- /.modal -->
        <div class="modal fade" id="viewModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Loan Details</h4>
              </div>
              <div class="modal-body">
                <!-- right column -->
                <div class="row">
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul
                          class="list-group list-group-unbordered mb-3"
                          v-if="seeRecord.branch"
                        >
                          <li class="list-group-item">
                            <b>Branch Name</b>
  
                            <a class="pull-right">{{ seeRecord.branch.name }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Branch Code</b>
                            <a class="pull-right">{{
                              seeRecord.branch.branchCode
                            }}</a>
                          </li>
  
                          <li class="list-group-item" v-if="seeRecord.member_id">
                            <b>Member Name</b>
                            <a class="pull-right">{{ seeRecord.member.name }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>PREVIOUS LOAN PLAN DETAILS</b>
                            <table
                              class="table table-sm table-striped table-dark"
                            >
                              <tr>
                                <td><b>Plan Name </b> : {{ pl.name }}</td>
                              </tr>
                              <tr>
                                <td><b>Plan Type </b> : {{ pl.planType }}</td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Type of Interest</b> : {{ pl.typeOfInterest }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Recovery Type</b> : {{ pl.recoveryType }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Number of Payments</b> :
                                  {{ pl.noOfPayments }}
                                </td>
                              </tr>
                              
                            </table>
                          </li>
                          <li class="list-group-item">
                            <b>New Loan Amount</b>
                            <a class="pull-right">{{
                              seeRecord.new_loan_amt
                            }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Create At</b>
                            <a class="pull-right">{{
                              seeRecord.created_at
                            }}</a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul
                          class="list-group list-group-unbordered mb-3"
                          v-if="seeRecord.branch"
                        >
                          <li class="list-group-item">
                            <b>PREVIOUS LOAN DETAILS</b>
                            <table
                              class="table table-sm table-striped table-dark"
                            >
                              <tr>
                                <td><b>Loan Application No. </b> : {{ seeRecord.previous_member_loan_plan.applicationNo }}</td>
                                
                              </tr>
                              <tr>
                                <td>
                                  <b>Due No Of EMI</b> : {{ seeRecord.previous_due_no_of_emi }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>First EMI Date</b> : {{ seeRecord.previous_disbursement.emiStartDate }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Last EMI Date</b> : {{ seeRecord.previous_disbursement.emiEndDate }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Total Amount</b> : {{ seeRecord.previous_loan_amt }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Principal Amount</b> : {{ seeRecord.previous_principal_amt }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Interest Amount</b> : {{ seeRecord.previous_interest_amt }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Due Amount</b> : {{ seeRecord.previous_due_amt }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Due Principal Amount</b> : {{ seeRecord.previous_loan_due_principal_amt }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Due Interest Amount</b> : {{ seeRecord.previous_loan_due_interest_amt }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Forclose Charges</b> : {{ seeRecord.previous_loan_forclose_charges }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Loan Interest Write Off Amount</b> : {{ seeRecord.previous_loan_discount }}
                                </td>
                              </tr>
                            </table>
                          </li>
                          <li class="list-group-item">
                            <b>Status</b>
                            <a class="pull-right">{{ seeRecord.status }}</a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                </div>
              </div>
              <div class="modal-footer text-center">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >
                  CLOSE
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <div class="modal fade" id="viewGroupMember">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Member Details</h4>
              </div>
              <div class="modal-body">
                <!-- right column -->
                <div class="row">
                  <div class="col-md-12">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group list-group-unbordered mb-3">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th>C/O</th>
                                <th>Address</th>
                                <th>City</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="groupmem">
                                <td>
                                  {{ groupmem.fatherName }}
                                </td>
                                <td>
                                  {{ groupmem.address}}
                                </td>
                                <td>
                                  {{groupmem.city}}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                </div>
              </div>
              <div class="modal-footer text-center">
                <button type="button" class="btn btn-danger" data-dismiss="modal">
                  CLOSE
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <!-- Demand Probeshnary note  -->
        <demandprobeshnarynote :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></demandprobeshnarynote>
        <!-- /.modal -->
        <!-- Aadhar Agreement Letter  -->
        <aadharagreementletter :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></aadharagreementletter>
        <!-- /.modal -->
        <!-- Previous Loan Record  -->
        <previousloanrecord :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :memberloanplans="memberloanplans" :logo="logo"></previousloanrecord>
        <!-- /.modal -->
      </section>
      <!-- /.content -->
    </div>
  </template>
  
  <script>
  import { Printd } from 'printd'
  import settingrecord from '../../mixins/SettingRecords'
  import demandprobeshnarynote from '../components/DemandProbeshnaryNote.vue'
  import aadharagreementletter from '../components/AdharAgreementLetter.vue'
  import previousloanrecord from '../components/PreviousLoanRecord.vue'
  import GetBranch from '../../mixins/BranchRecords'
  import GetMemberRecords from '../../mixins/GetMemberRecordSearch'
  import getPreviousLoan from '../../mixins/PreviousLoanRecord'
  import VueBarcode from 'vue-barcode'
  import VueLoanPlan from './ViewLoan.vue'
  export default {
    name: 'LoanTopup',
    mixins: [GetBranch, settingrecord, getPreviousLoan, GetMemberRecords],
    data () {
      return {
        cssText: `.printing {
          font-family: sans-serif;
          text-align: center;
          padding-bottom: 2rem;
  
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }
        @page {
          size: A4;
          margin: 0;
        }
        table.center {
          margin-left: auto; 
          margin-right: auto;
        }
        p {font-size:12px;}
        table, th, td { border:1px solid #000;font-size:12px; padding:0.4em; border-collapse: collapse; }`,
        pagination: {
          current_page: 0,
          from: 0,
          to: 0,
          total: 0,
          last_page: 0,
          per_page: 0,
          first_page_url: null,
          last_page_url: null,
          next_page_url: null,
          prev_page_url: null,
          path: null
        },
        userType: '',
        per_page: 10,
        table_search: '',
        processing: false,
        memberEMIs: [],
        totalAmt: 0,
        user: {},
        staffs: [],
        staf: {},
        editMode: false,
        planTypeApplied: 'inActive',
        logo: '',
        mem: {},
        guarantor: {},
        groupmem: {},
        memberDetail: {},
        collectionCenters: {},
        colC: {},
        branches: [],
        branch: {},
        branchcenters: [],
        branchcenter: {},
        members: [],
        member: {},
        bank_accounts: [],
        pl: {},
        processingFeeType: '',
        insuranceFeeType: '',
        seeRecord: {},
        loanplans: [],
        purposes: [],
        groupMembers: {},
        getCompanyRecord: {},
        viewCollectionCenter: '',
        getSettingRecord: '',
        userStatus: '',
        memberloanplans: [],
        paybleAmt: 0,
        paybleAmtWithForCloseCharge: 0,
        paybleAmtWithDiscount: 0,
        form: new Form({
          id: '',
          topup_id: '',
          previous_disbursement_id: '',
          previous_member_loan_plan_id: '',
          previous_remaining_amt: 0,
          previous_loan_amt: '',
          previous_principal_amt: '',
          previous_interest_amt: '',
          previous_paid_amt: '',
          previous_due_amt: '',
          previous_no_of_emi: '',
          previous_paid_no_of_emi: '',
          previous_due_no_of_emi: '',
          previous_loan_due_principal_amt: '',
          previous_loan_due_interest_amt: '',
          previous_loan_forclose_charges_type: 'fixed',
          previous_loan_forclose_charges: 0,
          previous_loan_discount: 0,
          new_loan_amt: '',
          new_disbursement_amt: 0,
          branch_center_id: '',
          collection_center_id: '',
          member_id: '',
          guarantor_id: null,
          branch_id: '',
          agent_id: null,
          center_leader_id: '',
          plan_id: '',
          plan: {},
          purpose: {},
          purpose_id: '',
          description: '',
          planType: 'individual',
          status: '',
          branch_ledger_id: '',
          disbursement_id: '',
          disbursementDate: new Date().toISOString().slice(0, 10),
          emiStartDate: '',
          amt: '',
          loanAmount: null,
          processingFee: null,
          insuranceFee: null,
          fileCharge: null,
          type: '',
          loanAmountType: '',
          paymentDate: null
        }),
        rows: []
      }
    },
    components: {
      'barcode': VueBarcode,
      'view-loan-plan': VueLoanPlan,
      demandprobeshnarynote,
      aadharagreementletter,
      previousloanrecord
    },
    methods: {
      canAccess (perm) {
        return this.$store.state.permissions.includes(perm)
      },
      getSelectPurpose () {
        this.form.purpose_id = ''
        this.form.purpose_id = this.form.purpose.id
      },
      newModalTopup () {
        var c = JSON.parse(localStorage.user)
        this.userType = c.type
        this.form.previous_disbursement_id = ''
        this.form.previous_member_loan_plan_id = ''
        this.form.previous_remaining_amt = ''
        this.form.previous_loan_amt = ''
        this.form.previous_principal_amt = 0
        this.form.previous_interest_amt = ''
        this.form.previous_paid_amt = ''
        this.form.previous_due_amt = ''
        this.form.previous_no_of_emi = 0
        this.form.previous_paid_no_of_emi = 0
        this.form.previous_due_no_of_emi = ''
        this.form.previous_loan_due_principal_amt = 0
        this.form.previous_loan_due_interest_amt = 0
        this.user = this.$store.state.user
        this.editMode = false
        this.form.loanAmountType = ''
        this.planTypeApplied = 'inActive'
        this.branchcenter = {}
        this.members = []
        this.guarantor = {}
        this.collectionCenters = []
        this.mem = {}
        this.guarantor = {}
        this.form.reset()
        if (c.type === 'staff') {
          this.form.branch_id = c.agent_profile.branch_id
          this.getMemberAndGroupAndAgent()
        }
        $('#newModalTopup').modal({backdrop: 'static', keyboard: false})
        // let loader = this.$loading.show()
      },
      applyTopupApprove (row) {
        var c = JSON.parse(localStorage.user)
        this.userType = c.type
        this.form.branch_id = null
        this.user = this.$store.state.user
        this.editMode = false
        this.form.loanAmountType = ''
        this.planTypeApplied = 'inActive'
        this.branchcenter = {}
        this.members = []
        this.form.topup_id = ''
        this.guarantor = {}
        this.staffs = []
        this.staf = {}
        this.collectionCenters = []
        this.mem = {}
        this.guarantor = {}
        this.form.reset()
        this.form.topup_id = row.id
        this.form.branch_id = row.branch_id
        this.form.member_id = row.member_id
        if (c.type === 'staff') {
          this.form.branch_id = c.agent_profile.branch_id
        }
        this.getMemberAndGroupAndAgent()
        $('#newModalLoan').modal({backdrop: 'static', keyboard: false})
        // let loader = this.$loading.show()
      },
      createLoan () {
        if (this.processing === true) {
          return false
        }
        this.processing = true
        this.form.planType = 'individual'
        if (this.form.planType === 'individual') {
          this.$delete(this.form, 'collection_center_id')
          this.$delete(this.form, 'center_leader_id')
        }
        this.$axios
          .post(`topupapprove/${this.form.topup_id}`, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            this.form.reset()
            Fire.$emit('AfterCreate')
            $('#newModalLoan').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Topup Approve Successfully'
            })
          })
          .catch(
            function (error) {
              if (error.response.data.error) {
                var result = []
                var er = error.response.data.error
                for (var l in er) {
                  if (er.hasOwnProperty(l)) {
                    result.push(l + ': ' + er[l])
                  }
                }
                Toast.fire({ icon: 'error', title: result.join('\n') })
              }
              if (error.response.data.message) {
                let er = error.response.data.message
                Toast.fire({ icon: 'error', title: er })
              }
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
        setTimeout(() => {
          this.processing = false
        }, 3000)
      },
      branchCenterWiseRecord () {
        this.form.branch_center_id = this.branchcenter.id
      },
      getPlanDetails (plan, val) {
        var planRecord = JSON.parse(plan)
        var value
        switch (val) {
          case 'name': value = planRecord.name
            break
          case 'planType': value = planRecord.planType
            break
          case 'noOfPayments': value = planRecord.noOfPayments
            break
          case 'disbursementAmount': value = planRecord.amount
            break
          case 'loanAmount': value = planRecord.amount
            if (planRecord.processingFeeIncludeAmt === 'true') {
              value = value + planRecord.processingFee
            }
            if (planRecord.fileChargeIncludeAmt === 'true') {
              value = value + planRecord.fileCharge
            }
            if (planRecord.insuranceFeeIncludeAmt === 'true') {
              value = value + planRecord.insuranceFee
            }
        }
        return value
      },
      getLoanEMI (mlp) {
        this.form.previous_disbursement_id = ''
        this.form.previous_member_loan_plan_id = ''
        this.form.previous_remaining_amt = 0
        this.form.previous_loan_amt = ''
        this.form.previous_principal_amt = 0
        this.form.previous_interest_amt = ''
        this.form.previous_paid_amt = ''
        this.form.previous_due_amt = ''
        this.form.previous_no_of_emi = 0
        this.form.previous_paid_no_of_emi = 0
        this.form.previous_due_no_of_emi = ''
        this.form.previous_loan_due_principal_amt = 0
        this.form.previous_loan_due_interest_amt = 0
        this.form.new_disbursement_amt = 0
        this.form.new_loan_amt = 0
        this.form.previous_disbursement_id = mlp.disbursement_id
        this.form.previous_member_loan_plan_id = mlp.id
        this.form.previous_loan_amt = mlp.totalAmt
        this.form.previous_principal_amt = this.getPlanDetails(mlp.disbursement.plan, 'loanAmount')
        this.form.previous_interest_amt = mlp.totalAmt - this.form.previous_principal_amt
        this.form.previous_paid_amt = mlp.receivedAmt
        var receivedAmount = mlp.receivedAmt
        this.form.previous_due_amt = mlp.totalAmt - mlp.receivedAmt
        this.form.previous_loan_due_principal_amt = this.form.previous_principal_amt
        this.form.previous_loan_due_interest_amt = this.form.previous_interest_amt
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + mlp.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberEMIs = data.data
          console.log(this.memberEMIs.length)
          if (this.memberEMIs.length > 0) {
            this.form.previous_no_of_emi = this.memberEMIs.length
            this.form.previous_paid_no_of_emi = parseInt(mlp.receivedAmt / (data.data[0].principal + data.data[0].intrest))
            this.form.previous_due_no_of_emi = this.form.previous_no_of_emi - this.form.previous_paid_no_of_emi
            // previous loan due principal amount and interest amount
            for (let i = 0; i < this.memberEMIs.length; i++) {
              if (receivedAmount >= parseInt(this.memberEMIs[i].principal + this.memberEMIs[i].intrest)) {
                // console.log('logic 1')
                // console.log(receivedAmount + ' Receive Amt')
                // console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                // console.log(this.memberEMIs[i].intrest + 'emi interest')
                this.form.previous_loan_due_interest_amt = this.form.previous_loan_due_interest_amt - this.memberEMIs[i].intrest
                console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                console.log(this.memberEMIs[i].principal + ' emi principal')
                this.form.previous_loan_due_principal_amt = this.form.previous_loan_due_principal_amt - this.memberEMIs[i].principal
                console.log(this.form.previous_loan_due_principal_amt + ' Previous Loan Due Principal Amt')
                receivedAmount = receivedAmount - parseInt(this.memberEMIs[i].principal + this.memberEMIs[i].intrest)
                console.log(receivedAmount + ' Receive Amt')
              } else {
                console.log('logic 2')
                if (receivedAmount > 0) {
                  console.log('logic 2.1')
                  if (receivedAmount >= parseInt(this.memberEMIs[i].intrest)) {
                    console.log('logic 2.1.1')
                    console.log(this.memberEMIs[i].intrest + 'emi interest')
                    this.form.previous_loan_due_interest_amt = this.form.previous_loan_due_interest_amt - parseInt(this.memberEMIs[i].intrest)
                    console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                    receivedAmount = receivedAmount - parseInt(this.memberEMIs[i].intrest)
                    console.log(receivedAmount + ' Receive Amt')
                    this.form.previous_loan_due_principal_amt = this.form.previous_loan_due_principal_amt - receivedAmount
                    console.log(this.form.previous_loan_due_principal_amt + ' Previous Loan Due Principal Amt')
                    receivedAmount = 0
                    console.log(receivedAmount + ' Receive Amt')
                  } else {
                    console.log('logic 2.1.2')
                    console.log(this.memberEMIs[i].intrest + 'emi interest')
                    this.form.previous_loan_due_interest_amt = this.form.previous_loan_due_interest_amt - receivedAmount
                    console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                    receivedAmount = 0
                    console.log(receivedAmount + ' Receive Amt')
                    // this.form.previous_loan_due_principal_amt = this.form.previous_loan_due_principal_amt - receivedAmount
                  }
                }
              }
            }
            this.paybleAmt = this.form.previous_loan_due_principal_amt + this.form.previous_loan_due_interest_amt
            this.paybleAmtWithForCloseCharge = this.paybleAmt
            this.paybleAmtWithDiscount = this.paybleAmt
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getPaybleAmount () {
        this.paybleAmtWithForCloseCharge = 0
        this.paybleAmtWithForCloseCharge = this.paybleAmt + parseInt(this.form.previous_loan_forclose_charges)
        if (this.paybleAmtWithForCloseCharge > 0) {
          this.paybleAmtWithDiscount = this.paybleAmtWithForCloseCharge - parseInt(this.form.previous_loan_discount)
        } else {
          this.paybleAmtWithDiscount = this.paybleAmt - parseInt(this.form.previous_loan_discount)
        }
      },
      changeLoanAmountType () {
        if (this.form.loanAmountType === 'static') {
          this.form.loanAmount = null
          this.form.fileCharge = null
          this.form.processingFee = null
          this.form.insuranceFee = null
        } else if (this.form.loanAmountType === 'dynamic') {
          this.form.loanAmount = this.form.plan.amount
          this.form.fileCharge = this.form.plan.fileCharge
          this.form.processingFee = this.form.plan.processingFee
          this.form.insuranceFee = this.form.plan.insuranceFee
        }
      },
      getRecordMemberWise () {
        this.form.member_id = ''
        if (this.member) {
          this.form.member_id = this.member.user_id
        }
        this.changeFilter()
      },
      getBranchRecord (branch) {
        this.form.branch_id = ''
        if (branch) {
          this.form.branch_id = branch.id
        }
        this.changeFilter()
      },
      planName (plan) {
        var pln = JSON.parse(plan)
        return pln.name
      },
      planAmt (row) {
        var fpi = 0
        var gstAmt = 0
        var pln = JSON.parse(row.plan)
        if (pln.planType !== 'normal') {
          if (pln.fileChargeIncludeAmt === 'true') {
            fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
          }
          if (pln.processingFeeIncludeAmt === 'true') {
            fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
          }
          if (pln.insuranceFeeIncludeAmt === 'true') {
            fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
          }
          if (pln.includeGst === 'true') {
            gstAmt = fpi * 18 / 100
            fpi += parseInt(gstAmt)
          }
          return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
        } else {
          return row.loanAmount ? row.loanAmount : pln.amount
        }
      },
      viewTopupRecord (row) {
        this.form.reset()
        this.seeRecord = {}
        $('#viewModal').modal({backdrop: 'static', keyboard: false})
        this.seeRecord = row
        this.pl = JSON.parse(row.previous_disbursement.plan)
      },
      deleteTopup (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            this.$axios
              .delete('topupdisbursement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
              .then((data) => {
                // console.log(data)
                Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
                Fire.$emit('AfterCreate')
              }).catch(function (error) { console.log(error) })
          }
        })
      },
      viewMemberAddDetail (id) {
        this.groupmem = {}
        this.$axios
          .get('member?all=all&user_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.groupmem = data.data[0]
          })
          .catch(function (error) { console.log(error) })
        $('#viewGroupMember').modal({backdrop: 'static', keyboard: false})
        // this.viewCollectionCenter = collection_center.id
        // console.log(collection_center.id)
      },
      viewPreviousLoanRecords (row) {
        this.seeRecord = row
        this.loadCompanyProfile()
        this.getPreviousLoanRecord(row.member_id)
        $('#viewPreviousLoanRecord').modal({backdrop: 'static', keyboard: false})
      },
      getBranchAgent () {
        this.form.agent_id = this.staf.user_id
      },
      getBranchMember () {
        this.form.previous_disbursement_id = ''
        this.form.previous_member_loan_plan_id = ''
        this.form.previous_remaining_amt = ''
        this.form.previous_loan_amt = ''
        this.form.previous_principal_amt = 0
        this.form.previous_interest_amt = ''
        this.form.previous_paid_amt = ''
        this.form.previous_due_amt = ''
        this.form.previous_no_of_emi = 0
        this.form.previous_paid_no_of_emi = 0
        this.form.previous_due_no_of_emi = ''
        this.form.previous_loan_due_principal_amt = 0
        this.form.previous_loan_due_interest_amt = 0
        this.form.member_id = this.mem.user_id
        this.getPreviousLoanRecord(this.mem.user_id, 'processing')
      },
      getLoanGuarantor () {
        this.form.guarantor_id = this.guarantor.user_id
      },
      getBranchCollectionCenter () {
        this.form.collection_center_id = this.colC.id
        this.loadGroupMember(this.form.collection_center_id)
      },
      createTopup () {
        if (this.processing === true) {
          return false
        }
        this.processing = true
        this.$axios
          .post('topup', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            this.form.reset()
            Fire.$emit('AfterCreate')
            $('#newModalTopup').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Create Topup Successfully'
            })
          })
          .catch(
            function (error) {
              if (error.response.data.error) {
                var result = []
                var er = error.response.data.error
                for (var l in er) {
                  if (er.hasOwnProperty(l)) {
                    result.push(l + ': ' + er[l])
                  }
                }
                Toast.fire({ icon: 'error', title: result.join('\n') })
              }
              if (error.response.data.message) {
                let er = error.response.data.message
                Toast.fire({ icon: 'error', title: er })
              }
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
        setTimeout(() => {
          this.processing = false
        }, 3000)
      },
      disbursmentModal (row) {
        this.form.reset()
        $('#disbursmentModal').modal({backdrop: 'static', keyboard: false})
        this.form.fill(row)
        // this.form.plan = JSON.parse(row.plan)
        this.form.disbursement_id = row.id
        this.getBranchBankAccount(row.branch_id)
      },
      fileChargeModal (row) {
        this.form.reset()
        this.pl = {}
        this.pl = JSON.parse(row.plan)
        $('#fileChargeModal').modal({backdrop: 'static', keyboard: false})
        this.form.fill(row)
        this.form.type = 'fileCharge'
        this.form.paymentDate = new Date().toISOString().slice(0, 10)
        if (this.pl.includeGst === 'true') {
          this.form.amt = row.fileCharge ? row.fileCharge + (row.fileCharge * 18 / 100) : this.pl.fileCharge + (this.pl.fileCharge * 18 / 100)
        } else {
          this.form.amt = row.fileCharge ? row.fileCharge : this.pl.fileCharge
        }
        // this.form.plan = JSON.parse(row.plan)
        this.form.disbursement_id = row.id
        this.getBranchBankAccount(row.branch_id)
      },
      processingFeeModal (row) {
        var pfamt = 0
        this.form.reset()
        this.pl = {}
        this.pl = JSON.parse(row.plan)
        $('#processingFeeModal').modal({backdrop: 'static', keyboard: false})
        this.form.fill(row)
        this.form.type = 'processingFee'
        this.form.paymentDate = new Date().toISOString().slice(0, 10)
        if (this.pl.processingFeeType === 'percent') {
          pfamt = row.loanAmount ? (this.pl.processingFee * row.loanAmount / 100) : (this.pl.processingFee * this.pl.amount / 100)
          if (this.pl.includeGst === 'true') {
            this.form.amt = pfamt + pfamt * 18 / 100
          } else {
            this.form.amt = pfamt
          }
        }
        if (this.pl.processingFeeType === 'fixed') {
          pfamt = row.processingFee ? row.processingFee : this.pl.processingFee
          if (this.pl.includeGst === 'true') {
            this.form.amt = pfamt + pfamt * 18 / 100
          } else {
            this.form.amt = pfamt
          }
        }
        // this.form.plan = JSON.parse(row.plan)
        this.form.disbursement_id = row.id
        this.getBranchBankAccount(row.branch_id)
      },
      getBranchBankAccount (id) {
        this.$axios
          .get('branchledger?all=all&status=active&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
          .then((data) => {
            this.bank_accounts = data.data
            $.each(this.bank_accounts, function (key, value) {
              this.bank_accounts[key].name = value.ledger.name
            }.bind(this))
          }).catch(function (error) { console.log(error) })
      },
      createDisbursement () {
        if (this.processing === true) {
          return false
        }
        this.processing = true
        if (this.form.planType === 'group') {
          this.$delete(this.form, 'member_id')
        }
        if (this.form.planType === 'individual') {
          this.$delete(this.form, 'collection_center_id')
          this.$delete(this.form, 'center_leader_id')
        }
        this.$axios
          .post('disbursement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            this.form.reset()
            Fire.$emit('AfterCreate')
            $('#disbursmentModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'New Loan Disbursed Successfully'
            })
          })
          .catch(function (error) {
            Swal.fire('Failed!', error.response.data.error, 'error')
            this.form.errors.errors = error.response.data.error
            // console.log(error.response.data.error)
          }.bind(this)
          )
        setTimeout(() => {
          this.processing = false
        }, 3000)
      },
      editModal (row) {
        // console.log(row)
        this.editMode = true
        this.form.reset()
        this.form.fill(row)
        if (this.form.loanAmount != null) {
          this.form.loanAmountType = 'dynamic'
        } else {
          this.form.loanAmountType = 'static'
        }
        // this.form.plan = JSON.parse(row.plan)
        this.getMemberAndGroupAndAgent()
        $('#newModalTopup').modal({backdrop: 'static', keyboard: false})
        if (row.planType === 'group') {
          this.loadGroupMember(this.form.collection_center_id)
        }
        this.form.plan = _.find(this.loanplans, function (o) {
          return o.id === row.plan_id
        })
        // console.log(this.form.plan)
      },
  
      updateLoan () {
        // console.log('update data')
        if (this.form.planType === 'group') {
          this.$delete(this.form, 'member_id')
        }
        if (this.form.planType === 'individual') {
          // alert('hello')
          this.$delete(this.form, 'center_leader_id')
          this.$delete(this.form, 'collection_center_id')
        }
        this.$axios
          .put('disbursement/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            this.form.reset()
            Fire.$emit('AfterCreate')
            $('#newModalLoan').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Loan Details Updated Successfully'
            })
          })
          .catch(
            function (error) {
              if (error.response.data.error) {
                var result = []
                var er = error.response.data.error
                for (var l in er) {
                  if (er.hasOwnProperty(l)) {
                    result.push(l + ': ' + er[l])
                  }
                }
                Toast.fire({ icon: 'error', title: result.join('\n') })
              }
              if (error.response.data.message) {
                let er = error.response.data.message
                Toast.fire({ icon: 'error', title: er })
              }
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      deleteModal (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$axios
              .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
              .then(() => {
                Fire.$emit('AfterCreate')
  
                Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
              })
              .catch(() => {
                Swal.fire('Failed!', 'There was something wrong.', 'error')
              })
          }
        })
      },
      getSelectPlan () {
        this.form.plan_id = this.form.plan.id
        this.form.loanAmount = this.form.plan.amount
        this.form.fileCharge = this.form.plan.fileCharge
        this.form.processingFee = this.form.plan.processingFee
        this.processingFeeType = this.form.plan.processingFeeType
        this.insuranceFeeType = this.form.plan.insuranceFeeType
        if (this.form.plan.planType === 'normal' || this.form.plan.planType === 'normalReduced' || this.form.plan.planType === 'interest') {
          this.planTypeApplied = 'active'
        } else {
          this.planTypeApplied = 'inActive'
          this.form.loanAmountType = 'static'
        }
      },
      getPlanType () {
        this.form.center_leader_id = null
        this.form.collection_center_id = null
        this.form.member_id = null
      },
      getMemberAndGroupAndAgent () {
        var c = JSON.parse(localStorage.user)
        this.userStatus = ''
        if (c.type === 'staff') {
          if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
            this.staf = this.user.agent_profile
            this.staf.name = this.user.name + ' (' + this.user.code + ')'
            this.form.agent_id = this.staf.user_id
          } else {
            this.loadStaff()
          }
        } else {
          this.loadStaff()
        }
        var pageUrl = 'member?all=all'
        if (this.getSettingRecord === 'true') {
          pageUrl += '&status=verified'
        }
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
        if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
          pageUrl += `&agent_id=${c.id}`
        }
        this.$axios
          .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.members = data.data
            _.forEach(this.members, function (item, key) {
              this.members[key].name = key + 1 + '- ' + item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
              if (this.form.member_id === item.user.id) {
                this.mem = item
              }
            }.bind(this))
          })
          .catch(
            function (error) {
              if (error.response.data.error) {
                var result = []
                var er = error.response.data.error
                for (var l in er) {
                  if (er.hasOwnProperty(l)) {
                    result.push(l + ': ' + er[l])
                  }
                }
                Toast.fire({ icon: 'error', title: result.join('\n') })
              }
              if (error.response.data.message) {
                let er = error.response.data.message
                Toast.fire({ icon: 'error', title: er })
              }
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
        this.$axios
          .get('branchcenter?all=all&status=active&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.branchcenters = data.data
            _.forEach(this.branchcenters, function (item, key) {
              this.branchcenters[key].name = item.name + ' (' + item.code + ')'
            }.bind(this))
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      loadStaff () {
        this.$axios
          .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.staffs = data.data
            _.forEach(this.staffs, function (item, key) {
              this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
              if (this.form.agent_id === item.user.id) {
                this.staf = item
              }
            }.bind(this))
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      loadLoan () {
        this.$axios
          .get('loanplan?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.loanplans = data.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      showPlanAmtNormal (pl) {
        return pl.amount
      },
      showPlanAmtReduced (pl) {
        if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'false') {
          return parseInt(pl.amount)
        } else if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'true') {
          return parseInt(pl.amount) + parseInt(pl.processingFee)
        } else if (pl.fileChargeIncludeAmt === 'true' && pl.processingFeeIncludeAmt === 'false') {
          return parseInt(pl.amount) + parseInt(pl.fileCharge)
        } else {
          return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
        }
      },
      loadPurpose () {
        this.$axios
          .get('purpose?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.purposes = data.data
            $.each(this.purposes, function (key, value) {
              this.purposes[key].name = value.purpose
            }.bind(this))
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      loadCompanyProfile () {
        let loader = this.$loading.show()
        this.$axios
          .get('settings', {
            headers: { Authorization: 'Bearer ' + localStorage.token }
          })
          .then((response) => response.data)
          .then((data) => {
            loader.hide()
            this.getCompanyRecord = data
            if (this.getCompanyRecord.logo != null) {
              this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
            } else {
              alert('hello')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      print () {
        const d = new Printd()
        d.print(document.getElementById('print'), [this.cssText])
      },
      planRecoveryType (plan) {
        var pln = JSON.parse(plan)
        return pln.recoveryType
      },
      changeFilter (page = null, pg = null) {
        let loader = this.$loading.show()
        var c = JSON.parse(localStorage.user)
        var pageUrl = ''
        if (this.pagination.first_page_url && pg === 'first') {
          pageUrl += this.pagination.first_page_url
        } else if (this.pagination.last_page_url && pg === 'last') {
          pageUrl += this.pagination.last_page_url
        } else if (this.pagination.next_page_url && pg === 'next') {
          pageUrl += this.pagination.next_page_url
        } else if (this.pagination.prev_page_url && pg === 'prev') {
          pageUrl += this.pagination.prev_page_url
        } else if (this.pagination.path != null) {
          pageUrl += this.pagination.path
        } else {
          pageUrl += 'topup'
        }
        if (pg == null) {
          pageUrl += `?per_page=${this.per_page}`
        } else {
          pageUrl += `&per_page=${this.per_page}`
        }
        if (this.table_search) {
          pageUrl += `&searchTerm=${this.table_search}`
        }
        if (page != null) {
          pageUrl += `&page=${page}`
        }
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
        if (c.role.name === 'Agent') {
          pageUrl += `&agent_id=${c.id}`
        }
        if (this.form.member_id) {
          pageUrl += `&member_id=${this.form.member_id}`
        }
        this.$axios
          .get(`${pageUrl}`, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
          .then((data) => {
            loader.hide()
            this.rows = data.data.data
            this.pagination = data.data
          }).catch(function (error) { console.log(error) })
      }
    },
  
    created () {
      // this.loadMember()
      this.loadSettings()
      this.changeFilter()
      this.getBranch()
      // var c = JSON.parse(localStorage.user)
      // if (c.type === 'admin') {
      //   this.getBranch()
      // }
      this.loadLoan()
      this.loadPurpose()
      Fire.$on('AfterCreate', () => {
        this.changeFilter()
      })
    }
  }
  </script>
  <style scoped>
    @media print {
      .modal {
        position: absolute;
        left: 0;
        top: 0;
        margin: 0;
        padding: 0;
        overflow: visible!important;
      }
    }
    .table-responsive {
      overflow-y: visible !important;
    }
    .content {
      padding: 0px;
    }
   .info-box {
      border-radius:10px;
      box-shadow: 0px 0px 3px gray;
    }
    .box-footer {
      border-radius:0px 0px 10px 10px;
    }
  </style>



// WEBPACK FOOTER //
// LoanTopup.vue?3a94f14e